import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Backdrop,
  CircularProgress,
  Snackbar,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { Colors } from "helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import { useState } from "react";
import useTable from "components/useTable";
import logger from "components/Logger"
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";


type Props = {
  open: boolean;
  handleClose: () => void;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function EditTableNumberDialog({ open, handleClose, shoppingBagQuery }: Props) {

  const [isLoading, setIsLoading] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { table_number, existingTables, isLoadingExistingTables, alterTableNumber }
    = useTable({shoppingBagQuery});



  const formik = useFormik({
    initialValues: {
      table_number:
        Number(table_number),
    },
    enableReinitialize: true,
    onSubmit: async (values: any) => {
      try{
        setIsLoading(true)

        const procurado = existingTables.filter((v:string) => Number(v) === values.table_number)

        if(procurado.length < 1) {

          // resetando o valor do form
          values.table_number = Number(table_number)
          setIsLoading(false)
          setMensagem("Mesa não encontrada.");
          setOpenSnackBar(true);

          logger.log('openSnackBar', openSnackBar)
          return;
        }

        await alterTableNumber(values.table_number)

        setIsLoading(true)

        formik.setSubmitting(false);
        setIsLoading(false)
        handleClose();

      }
    catch (e){
      setIsLoading(false)

      formik.setSubmitting(false);
      handleClose();
    }

    },
  });

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth={"lg"}
      >
        <Backdrop
          sx={{ color: 'rgba(70,70,70,0.8)'}}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleCloseSnackBar}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="error"
            sx={{ width: "100%" }}
          >
            <p>{mensagem}</p>
          </Alert>
        </Snackbar>
        <DialogTitle color={Colors.orangePrimary}>
          <Box display="flex" alignItems="center">
            <Box>
              <IconButton color="primary" onClick={handleClose}>
                <ArrowBackIosIcon fill={Colors.orangePrimary} />
              </IconButton>
            </Box>
            <Box
              flexGrow={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Mudar Mesa Pedido
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={formik.handleSubmit}>
            {isLoadingExistingTables && <Skeleton />}
            {!isLoadingExistingTables && (
              <Box>
              <TextField
                value={formik.values.table_number}
                onChange={formik.handleChange}
                placeholder="Qual a mesa que você está?"
                label="Qual a mesa que você está?"
                name="table_number"
                variant="standard"
                type="number"
                fullWidth
              />
            </Box>)}
            <Box display={"flex"} flexGrow={1}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                sx={{ color: "white", marginTop: "15px", width: "50%" }}
              >
                Sim
              </Button>
              <Button
                color="primary"
                variant="outlined"
                sx={{ marginTop: "15px", width: "50%", marginLeft: 2 }}
                onClick={() => handleClose()}
              >
                Não
              </Button>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default EditTableNumberDialog;
